
<div class="relative" :class="dropdownClasses">
  <select
    :id="id"
    v-model="selectedOption"
    class="dropdown-input"
    :aria-invalid="hasError"
    :aria-describedby="ariaDescribedByName"
    :required="required"
    :disabled="disabled"
    :name="name"
  >
    <!-- needs to accept an object or an array -->
    <option
      v-for="(option, index) in options"
      :id="index"
      :key="index"
      :value="option.hasOwnProperty('value') ? option.value : option"
    >
      {{ option.display ? option.display : option }}
    </option>
  </select>
  <label :class="dropdownSelectedOption" :for="id">{{ labelName }}</label>
  <slot />

  <div v-if="helperText" :id="ariaDescribedByName" class="mt-4 flex relative">
    <ErrorIcon v-if="hasError" class="mr-4 mt-4" />
    <p class="dropdown-helper">{{ helperText }}</p>
  </div>
</div>
